import React, { useEffect, useState } from 'react'
import { FilterBar, TableData, TxnLogView } from '../../components';
import { errorAlert } from '../../helpers/alerts';
import { currencyFormatter } from 'helpers/util';
import { Box } from '@mui/system';
import moment from 'moment';
import { getSearchTxnReportService } from 'services/report/reportService';
import { useLocation } from 'react-router-dom';
import DialogModal from 'components/modal/DialogModal';
import { getLogsTxnService } from 'services/panelService';
import { BugReport } from '@mui/icons-material';

const SearchTxnReportScreen = () => {
  const location = useLocation();
  const [loading, setLoading] = useState(false)
  const [list, setList] = useState([])
  const [dialog, setDialog] = useState({ open: false, title: '', body: '' });


  useEffect(() => {
    document.title = "Reporte de Transacciones"
  }, [])

  const columns = [
    { name: "carrier", label: "Operadora", format: ({ carrier }) => carrier?.name || '-' },
    { name: "phoneNumber", label: "Número", format: ({ phoneNumber }) => phoneNumber || '-' },
    { name: "import", label: "Importe", sort: ({ typeReg, amount, operacionSaldo }) => ['TAE', 'PDS', 'PIN'].includes(typeReg) ? parseFloat(amount) : parseFloat(operacionSaldo), format: ({ typeReg, amount, operacionSaldo }) => currencyFormatter.format(['TAE', 'PDS', 'PIN'].includes(typeReg) ? amount : operacionSaldo) },
    { name: "datetime", label: "Fecha y hora", sort: ({ createdAt }) => createdAt, format: ({ createdAt }) => moment(createdAt).format('DD/MM/YYYY HH:mm:ss') },
    { name: "commerce", label: "Comercio", format: ({ commerce }) => commerce?.username || '-' },
    { name: "estatus", label: "Estado", format: ({ ProviderResponseMessage }) => ProviderResponseMessage || '-' },
    { name: "code", label: "Código", format: ({ ProviderResponseCode }) => ProviderResponseCode || '-' },
    { name: "auth", label: "Autorización", format: ({ AuthCode }) => AuthCode || '-' },
    { category: 'Resultado', name: "time", label: "Tiempo", format: ({ createdAt, endTxn, updatedAt }) => `${(endTxn || updatedAt) - createdAt} ms` },
  ]

  const handlerSubmit = (filters) => {
    // if (location.state) {
    //   filters = location.state;
    // }
    if (!filters.period || !filters.phone) return;
    setLoading(true)
    getSearchTxnReportService(filters)
      .then((result) => setList(result.data))
      .catch((e) => errorAlert(e))
      .finally(() => setLoading(false))
  }

  return (
    <>
      <FilterBar
        handlerFilter={handlerSubmit}
        defaultValues={location.state || {}}
        filters={[
          {
            name: 'period',
            label: "Periodo",
            type: "select",
            data: [
              { id: 'day', name: "Día" },
              { id: 'week', name: "Semana" },
              { id: 'month', name: "Mes" },
              { id: 'all', name: "Todos" },
            ],
          },
          {
            name: 'phone',
            label: "Número",
            type: "text",
          },
        ]}
      />
      <Box mt={2} >
        <TableData
          loading={loading}
          dataRows={list}
          dataTitle={columns.map(({ label }) => label)}
          formatter={(data) => columns.map(({ format }) => format(data))}
          actions={[
            {
              label: "Logs",
              icon: <BugReport />,
              onClick: async (data) => {
                const result = await getLogsTxnService(data._id);
                setDialog({
                  open: true,
                  maxWidth: 'lg',
                  title: `Log Transacción ${data._id}`,
                  textAlign: 'left',
                  body: <TxnLogView data={result} />,
                  onClose: () => setDialog({ open: false })
                })
              },
            },
          ]
          }
        />
      </Box>
      <DialogModal
        open={dialog.open}
        title={dialog.title}
        body={dialog.body}
        maxWidth={dialog.maxWidth}
        textAlign={dialog.textAlign}
        onSuccess={dialog.onSuccess}
        onClose={dialog.onClose}
      />
    </>
  )
}

export default SearchTxnReportScreen